import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from "../../store.ts";

interface MissedCallData {
    count: number;
    lastMissedAt?: number;
}

interface NotificationData {
    show: boolean;
}

interface MissedCallsState {
    missedCallsByNumber: Record<string, MissedCallData>;
    showMissedCallNotification: Record<string, NotificationData>;
}

interface SetMissedCallsPayload {
    phoneNumber: number;
    count: number;
}

const initialState: MissedCallsState = {
    missedCallsByNumber: {},
    showMissedCallNotification: {}
}

const missedCallsSlice = createSlice({
    name: 'missedCalls',
    initialState,
    reducers: {
        setMissedCallsForNumber: (state, action: PayloadAction<SetMissedCallsPayload>) => {
            const { phoneNumber, count } = action.payload
            if(state.missedCallsByNumber[phoneNumber]?.count === count) return;

            if (count > 0 && phoneNumber) {
                state.missedCallsByNumber[phoneNumber] = {
                    count,
                    lastMissedAt: Date.now()
                }
                state.showMissedCallNotification[phoneNumber] = {
                    show: true,
                }
            }
        },
        clearMissedCallsForNumber: (state, action: PayloadAction<string>) => {
            const phoneNumber = action.payload
            delete state.missedCallsByNumber[phoneNumber]
            state.showMissedCallNotification[phoneNumber] = {
                show: false,
            }
        },
        setHideMissedCallNotification: (state, action: PayloadAction<string>) => {
            state.showMissedCallNotification[action.payload] = {
                show: false,
            };
        }
    }
})

export const {
    setMissedCallsForNumber,
    clearMissedCallsForNumber,
    setHideMissedCallNotification,
} = missedCallsSlice.actions

export const selectMissedCallsByNumber = (state: RootState): Record<string, MissedCallData> =>
    state.missedCalls?.missedCallsByNumber || {}

export const selectMissedCallsForNumber = (phoneNumber: string) => (state: RootState): MissedCallData =>
    state.missedCalls.missedCallsByNumber[phoneNumber] || { count: 0, lastMissedAt: undefined }

export const selectShowMissedCallNotification = (phoneNumber: string) => (state: RootState): boolean =>
    state.missedCalls.showMissedCallNotification[phoneNumber]?.show || false

export default missedCallsSlice.reducer